import { render, staticRenderFns } from "./successTrash.vue?vue&type=template&id=e64be7d0"
import script from "./successTrash.vue?vue&type=script&lang=js"
export * from "./successTrash.vue?vue&type=script&lang=js"
import style0 from "./successTrash.vue?vue&type=style&index=0&id=e64be7d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports